import { VehicleDetails } from './VehicleDetailsTable';
// import { VehicleFinesDetails } from './VehicleFinesTable';
import DetailsData from './Data/DetailsData.json';
import FinesData from './Data/FinesData.json';

export const Detailsdata = DetailsData;

export const Finesdata = FinesData;